import { Link } from "react-router-dom";
import { site, siteDisclaimer } from "@/mocks/site";

export default function Footer() {
  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-node-tree text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{site.name}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              {site.slogan}。把散落在各处的公开信息，整理成可以查证的时间线与观点地图。
            </p>
            <a
              href={`mailto:${site.email}`}
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800"
            >
              <i className="ri-mail-line text-base" aria-hidden="true"></i>
              {site.email}
            </a>
          </div>

          {/* 快速导航 */}
          <div>
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <i className="ri-compass-3-line text-base text-accent-600" aria-hidden="true"></i>
              快速导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {site.nav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 瓜田栏目 */}
          <div>
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <i className="ri-grid-line text-base text-accent-600" aria-hidden="true"></i>
              瓜田栏目
            </h4>
            <ul className="mt-4 space-y-2.5">
              {site.categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/events?cat=${cat.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 内容原则 */}
          <div>
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <i className="ri-shield-check-line text-base text-accent-600" aria-hidden="true"></i>
              内容原则
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>· 信息标注来源，事实与推测分层</li>
              <li>· 不做针对个人的负面「定罪」</li>
              <li>· 观点归属清楚，不做匿名站队</li>
              <li>· 鼓励以一手信源交叉验证</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 rounded-lg bg-background-200/60 px-4 py-3 text-xs leading-relaxed text-foreground-600 md:px-5">
          <p>{siteDisclaimer}</p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {site.name} · 一个努力让围观变清楚的整理平台
          </p>
          <div className="flex items-center gap-3">
            <a
              href={`mailto:${site.email}`}
              aria-label="联系我们"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition-colors hover:text-primary-700"
            >
              <i className="ri-mail-line text-lg" aria-hidden="true"></i>
            </a>
            <button
              type="button"
              onClick={goTop}
              aria-label="返回顶部"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}